import { render, staticRenderFns } from "./GoNormalBtn.vue?vue&type=template&id=4031e734&scoped=true&"
import script from "./GoNormalBtn.vue?vue&type=script&lang=js&"
export * from "./GoNormalBtn.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4031e734",
  null
  
)

export default component.exports